import React from 'react'
import { Waypoint } from 'react-waypoint'
import { useAppDispatch } from './app/hooks/reduxHooks'
import { setPage } from './app/pageIndexSlice'

export default function VisibilitySensor({ index }) {
    const dispatch = useAppDispatch()
    const handleEnterOnScreen = () => dispatch(setPage(index))
    return (
        <Waypoint onEnter={handleEnterOnScreen} />
    )
}
